// Penjaga simpan ganda: panggilan kedua selagi yg pertama masih berjalan diabaikan
// (klik ganda dlm hitungan milidetik terjadi sebelum tombol sempat dinonaktifkan React).
export function buatPenjagaSimpan() {
    let berjalan = false;
    return async (fn) => {
        if (berjalan) return { dilewati: true };
        berjalan = true;
        try {
            return await fn();
        } finally {
            berjalan = false;
        }
    };
}
